import{FormsBase}from"../../forms/base";import{AuthForm}from"../form";import"./index.scss";/**
 * Core: AuthFormRegister
 */export function AuthFormRegister($root,options={}){return AuthForm(),FormsBase($root,".authFormRegister",options)}export default AuthFormRegister;